module.exports = __webpack_public_path__ + "dd03d797a543ad87fd25ae8ef17a4e87.svg";